module.exports = ".swtool-drop li button {\r\n  width:100%;\r\n  border:none;\r\n  text-align: left;\r\n}\r\n\r\n\r\n"